module.exports = __webpack_public_path__ + "images/noun_icons/onespot-outline.svg";